export enum TableType {
  REGISTER = 0,
  TABLE = 1,
  PACKAGE = 2,
}
